import AkbsApp from './AkbsApp.vue'
import AkbsPendingList from './pages/AkbsPendingList.vue'
import AkbsInputForm from './pages/AkbsInputForm.vue'
import AkbsContractForm from './pages/AkbsContractForm.vue'
import AkbsRegisteredList from './pages/AkbsRegisteredList.vue'
import AkbsWage from './pages/AkbsWage.vue'
import AkbsOutput from './pages/AkbsOutput.vue'

export default {
  path: '/Akbs',
  component: AkbsApp,
  children: [
    {
      path: '/AkbsPendingList',
      name: 'AkbsPendingList',
      component: AkbsPendingList,
      meta: { requiresAuth: true, title: 'apollo-RP - 申請一覧' },
      props: true
    },
    {
      path: '/AkbsInputForm',
      name: 'AkbsInputForm',
      component: AkbsInputForm,
      meta: { requiresAuth: true, title: 'apollo-RP - 雇用指示登録' },
      props: true
    },
    {
      path: '/AkbsContractForm',
      name: 'AkbsContractForm',
      component: AkbsContractForm,
      meta: { requiresAuth: true, title: 'apollo-RP - 契約詳細登録' },
      props: true
    },
    {
      path: '/AkbsRegisteredList',
      name: 'AkbsRegisteredList',
      component: AkbsRegisteredList,
      meta: { requiresAuth: true, title: 'apollo-RP - AKBS登録済み一覧' },
      props: true
    },
    {
      path: '/AkbsWage',
      name: 'AkbsWage',
      component: AkbsWage,
      meta: { requiresAuth: true, title: 'apollo-RP - 賃金' },
      props: true
    },
    {
      path: '/AkbsOutput',
      name: 'AkbsOutput',
      component: AkbsOutput,
      meta: { requiresAuth: true, title: 'apollo-RP - 出力' },
      props: true
    },
  ]
}
